import React, { Component } from "react";
import { Link } from "react-router-dom";

export default class HomePage extends Component {
  constructor(props) {
    console.log(props);
    super(props);
  }
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="container-fluid">
          <h1>Breeze</h1>
          <hr />
          <h4>Search</h4>
          <p>
            <a href="/breeze/content-search" className="ContentTitle">
              Content Search
            </a>
          </p>
		{/*

          <p>
            <a href="/breeze/content-viewer" className="ContentTitle">
              Content Viewer
            </a>
          </p>
          <p>
            <a href="/breeze/content-editor" className="ContentTitle">
              Content Editor
            </a>
          </p>
          <h4>Content Properties</h4>
          <p>
            <a href="/breeze/create-content" className="ContentTitle">
              Create Content
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-type" className="ContentTitle">
              Create Content Type
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-annotation" className="ContentTitle">
              Create Content Annotation
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-application" className="ContentTitle">
              Create Content Application
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-association" className="ContentTitle">
              Create Content Association
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-association-type" className="ContentTitle">
              Create Content Association Type
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-category" className="ContentTitle">
              Ceate Content Category
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-category-type" className="ContentTitle">
              Create Content Category Type
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-descriptor" className="ContentTitle">
              Ceate Content Descriptor
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-descriptor-type" className="ContentTitle">
              Create Content Descriptor Type
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-facade" className="ContentTitle">
              Create Content Facade
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-facade-type" className="ContentTitle">
              Create Content Facade Type
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-index" className="ContentTitle">
              Ceate Content Index
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-index-type" className="ContentTitle">
              Create Content Index Type
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-template" className="ContentTitle">
              Ceate Content Template
            </a>
          </p>
          <p>
            <a href="/breeze/create-content-template-type" className="ContentTitle">
              Create Content Template Type
            </a>
          </p>

          <hr />
          <h4>Manage Content Properties</h4>

          <p>
            <a href="/breeze/manage-content" className="ContentTitle">
              Manage Content
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-types" className="ContentTitle">
              Manage Content Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-associations" className="ContentTitle">
              Manage Content Associations
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-association-types" className="ContentTitle">
              Manage Content Associations Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-categories" className="ContentTitle">
              Manage Content Categories
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-category-types" className="ContentTitle">
              Manage Content Category Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-descriptors" className="ContentTitle">
              Manage Content Descriptors
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-descriptor-types" className="ContentTitle">
              Manage Content Descriptor Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-facades" className="ContentTitle">
              Manage Content Facades
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-facade-types" className="ContentTitle">
              Manage Content Facade Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-indices" className="ContentTitle">
              Manage Content Indices
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-index-types" className="ContentTitle">
              Manage Content Index Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-templates" className="ContentTitle">
              Manage Content Templates
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-template-types" className="ContentTitle">
              Manage Content Template Types
            </a>
          </p>
          <p>
            <a href="/breeze/manage-content-transformations" className="ContentTitle">
              Manage Content Transformations
            </a>
          </p>
                    */}

          <hr />
          <h4>Catalog</h4>
        <p>
          <a href="/breeze/list-content" className="ContentTitle">
            Data Catalog
          </a>
        </p>
        <p>
          <a href="/breeze/list-image-catalog" className="ContentTitle">
            Image Catalog
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-associations" className="ContentTitle">
            Associations
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-categories" className="ContentTitle">
            Categories
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-descriptors" className="ContentTitle">
            Descriptors
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-facades" className="ContentTitle">
            Facades
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-indices" className="ContentTitle">
            Indices
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-templates" className="ContentTitle">
            Templates
          </a>
        </p>
        {/*
        <p>
          <a href="/breeze/list-content-types" className="ContentTitle">
            Types
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-association-types" className="ContentTitle">
            Association Types
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-category-types" className="ContentTitle">
            Category Types
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-template-types" className="ContentTitle">
            Template Types
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-index-types" className="ContentTitle">
            Index Types
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-descriptor-types" className="ContentTitle">
            Descriptor Types
          </a>
        </p>
        <p>
          <a href="/breeze/list-content-facade-types" className="ContentTitle">
            Facade Types
          </a>
        </p>
        */}
                </div>

      </form>
    );
  }
}
